const GlobalDeleteModal = ({ onDeleted, isDeleting }) => {
  return (
    <div
      id="delete-modal"
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="delete-modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="delete-modalLabel">
              Confirm Deletion
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body"> 
            <i
              className="ti ti-alert-circle"
              style={{ fontSize: "2rem", color: "#dc3545" }}
            ></i>
            <h5 className="mt-1">Are you sure?</h5>
            <p className="text-muted mt-1">
              This action will <strong>delete</strong> this item. It will no
              longer be visible.
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
              disabled={isDeleting}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={onDeleted}
              disabled={isDeleting}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalDeleteModal;
